export default () => ({
    loader: {
        color: '#fff'
    },
    pauseButton: {
        minWidth: 200
    }
});
